/**
 * 请求公共参数
 */
export const getCommonParams = () => {
  return {
    terminal: window._terminal,
    shopId: window._shopId,
  };
};
